import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { DataTable as DataTablePrimeReact } from 'primereact/datatable';
import { Column } from 'primereact/column';
import * as PropTypes from 'prop-types';
import {
    SelectControl,
    InputControl,
    Button,
    Container,
    Row,
    Col,
    CardV2,
    CardBody,
    CardContent,
    CardDesc,
    CardHeader,
    ButtonGroup,
} from '@si-armes/dsfr-react';
import 'primeicons/primeicons.css';
import './DataTableDesignEtat.scss';
import AffichageResponsive from '../AffichageResponsive';
import { formaterOptions } from '../../../utils/utils';

const EagerDataTableDesignEtat = ({
    records,
    columns,
    nombreTotal,
    rowClassName,
    clearFiltersButton,
    clearFiltersForce,
    customResultatName,
    exportButtonFonction,
    rowHover,
    onRowClick,
    areLignesSelectionnables,
    selectionListener,
    emptyMessage,
    rechercheIcon,
}) => {
    const { register, reset } = useForm();

    const triParDefaut = { sortField: '', sortOrder: -1 };

    // --- STATE ---
    const [lignesSelectionnees, setLignesSelectionnees] = useState([]);
    const [sort, setSort] = useState(triParDefaut);
    const [dataTable] = useState([]);
    const [afficherFiltres, setAfficherFiltres] = useState(false);

    // --- FILTRE ---

    const onFilterChangeContains = (event) => {
        dataTable.filter(event.target.value, event.target.id, 'contains');
    };

    const onFilterChangeExact = (event) => {
        dataTable.filter(event.target.value, event.target.id, 'contains');
    };

    const onClearFilters = () => {
        dataTable.reset();
        setSort(triParDefaut);
        const objectForReset = {};
        columns.forEach((column) => {
            objectForReset[column.field] = null;
        });
        reset(objectForReset);
    };

    useEffect(() => {
        if (clearFiltersForce) {
            onClearFilters();
        }
    }, [clearFiltersForce]);

    const onChangeSort = (sortToChange) => {
        setSort(sortToChange);
    };

    const getFilterTemplate = (column, estMobile) => {
        const labelFiltre = estMobile && column.header;
        if (
            (!column.filterType && rechercheIcon === true) ||
            (column.filterType === 'text' && rechercheIcon === true)
        ) {
            return (
                <InputControl
                    label={labelFiltre}
                    icon="fr-fi-search-line"
                    {...register(column.field)}
                    onChange={onFilterChangeContains}
                />
            );
        }
        if (!column.filterType || column.filterType === 'text') {
            return (
                <InputControl
                    label={labelFiltre}
                    {...register(column.field)}
                    onChange={onFilterChangeContains}
                />
            );
        }
        if (column.filterType === 'list') {
            return (
                <SelectControl
                    label={labelFiltre}
                    onChange={onFilterChangeExact}
                    options={formaterOptions(column.filterList)}
                    {...register(column.field)}
                />
            );
        }
        return null;
    };

    // --- SELECTION ---

    // réinitialise les lignes sélectionnées si les données de départs changent
    useEffect(() => {
        setLignesSelectionnees([]);
    }, [records]);

    useEffect(() => {
        if (selectionListener) {
            selectionListener(lignesSelectionnees);
        }
    }, [lignesSelectionnees]);

    const creerChampsTri = () => {
        return (
            <>
                <Col col={12} md={6}>
                    <SelectControl
                        id="champ-tri"
                        name="champ-tri"
                        label="Trier selon"
                        onChange={(event) =>
                            onChangeSort({ ...sort, sortField: event.target.value })
                        }
                        options={formaterOptions(columns.filter((column) => column.sortable))}
                    />
                </Col>
                <Col col={12} md={6}>
                    <SelectControl
                        id="ordre-tri"
                        name="ordre-tri"
                        label="Ordre du tri"
                        onChange={(event) =>
                            onChangeSort({ ...sort, sortOrder: parseInt(event.target.value, 10) })
                        }
                        value={sort.sortOrder}
                        options={[
                            {
                                name: 'Tri croissant',
                                value: '1',
                            },
                            {
                                name: 'Tri décroissant',
                                value: '-1',
                            },
                        ]}
                    />
                </Col>
            </>
        );
    };

    const majSelectionGlobale = () => {
        if (lignesSelectionnees.length === records.length) {
            setLignesSelectionnees([]);
        } else {
            setLignesSelectionnees(records);
        }
    };

    /** On vérifie que la ligne en entrée n'est pas déjà sélectionnée.
     * si elle l'est on la dé-sélectionne, sinon on la sélectionne */
    const majSelection = (value) => {
        if (value && value.length > 0) {
            const ligneAEnlever = lignesSelectionnees.find((ligne) => ligne === value[0]);
            if (ligneAEnlever) {
                setLignesSelectionnees(
                    lignesSelectionnees.filter((ligne) => ligne !== ligneAEnlever),
                );
            } else {
                setLignesSelectionnees(lignesSelectionnees.concat(value));
            }
        }
    };

    const genererBodySelection = (rowData, estMobile) => {
        let afficherCaseCochee = false;

        lignesSelectionnees.forEach((ligneSelectionnee) => {
            if (rowData === ligneSelectionnee) {
                afficherCaseCochee = true;
            }
        });
        return (
            <div className={`fr-checkbox-group fr-checkbox-group--${estMobile ? 'lg' : 'sm'}`}>
                <input
                    type="checkbox"
                    checked={afficherCaseCochee}
                    onChange={() => majSelection([rowData])}
                />
                {/* Fonctionnement du design etat qui va à l'encontre de la règle. On ne peut pas non plus avoir un id unique */}
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */}
                <label className="fr-label" />
            </div>
        );
    };

    const genererHeaderSelection = () => {
        let afficherCaseCochee = false;
        if (lignesSelectionnees.length === records.length) {
            afficherCaseCochee = true;
        }
        return (
            <div className="fr-checkbox-group fr-checkbox-group--sm">
                <input
                    type="checkbox"
                    id="checkboxHeader"
                    name="checkboxHeader"
                    checked={afficherCaseCochee}
                    onChange={() => majSelectionGlobale()}
                />
                {/* Fonctionnement du design etat qui va à l'encontre de la règle */}
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="fr-label" htmlFor="checkboxHeader" />
            </div>
        );
    };

    const creerCarteResultat = (resultat) => {
        return (
            <Col col={12} md={6} className="padding-carte">
                <CardV2 noEnlargeLink>
                    <CardBody>
                        <CardContent>
                            <CardDesc>
                                {columns
                                    .filter((column) => column.header)
                                    .map((column) => (
                                        <p>
                                            <b>{column.header} : </b>
                                            {resultat[column.field]}
                                        </p>
                                    ))}
                            </CardDesc>
                        </CardContent>
                    </CardBody>
                    {areLignesSelectionnables && (
                        <CardHeader>
                            <Container>
                                <Row className="boutons-carte">
                                    <Col>
                                        <div
                                            onClick={() => majSelection([resultat])}
                                            onKeyDown={() => majSelection([resultat])}
                                            role="button"
                                            tabIndex="0"
                                        >
                                            {genererBodySelection(resultat, true)}
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                    )}
                </CardV2>
            </Col>
        );
    };

    return (
        <Container fluid={false}>
            <Row gutters verticalAlign="middle">
                <Col col={12} sm={5}>
                    {clearFiltersButton && (
                        <Button onClick={onClearFilters} variant="secondary">
                            Réinitialiser les filtres
                        </Button>
                    )}{' '}
                    {exportButtonFonction && (
                        <Button onClick={exportButtonFonction} variant="secondary">
                            Exporter
                        </Button>
                    )}
                </Col>
                <Col col={12} sm={2}>
                    {nombreTotal && (
                        <>
                            {nombreTotal} {customResultatName || 'résultat'}
                            {nombreTotal > 1 && 's'}
                        </>
                    )}
                </Col>
            </Row>
            <AffichageResponsive
                pointDeRupture="xl"
                composantDesktop={
                    <DataTablePrimeReact
                        className="fr-table fr-table--bordered"
                        value={records}
                        rows={nombreTotal}
                        totalRecords={nombreTotal}
                        onSort={onChangeSort}
                        sortField={sort.sortField}
                        sortOrder={sort.sortOrder}
                        rowClassName={rowClassName}
                        rowHover={rowHover}
                        onRowClick={onRowClick}
                        selection={lignesSelectionnees}
                        onSelectionChange={(e) => majSelection(e.value)}
                        selectionMode="multiple"
                        emptyMessage={emptyMessage}
                        filterDisplay="row"
                    >
                        {areLignesSelectionnables && (
                            <Column
                                key="checkbox"
                                field="checkbox"
                                header={genererHeaderSelection()}
                                body={(rowData) => genererBodySelection(rowData, false)}
                                style={{ paddingLeft: 0, paddingRight: 0, width: 30 }}
                            />
                        )}
                        {columns.map((column) => {
                            const otherAttributes = {};
                            if (column.template) {
                                otherAttributes.body = column.template;
                            }
                            if (column.filter) {
                                otherAttributes.filterMatchMode = 'contains';
                                otherAttributes.showFilterMenu = false;
                                otherAttributes.filterElement = getFilterTemplate(column, false);
                            }
                            return (
                                <Column
                                    key={column.field}
                                    field={column.field}
                                    header={column.header}
                                    sortable={column.sortable}
                                    filter={column.filter}
                                    {...otherAttributes}
                                />
                            );
                        })}
                    </DataTablePrimeReact>
                }
                composantMobile={
                    <>
                        <Row gutters className="margin-top-sm">
                            <Col>
                                <ButtonGroup inline>
                                    <Button
                                        onClick={() => setAfficherFiltres(!afficherFiltres)}
                                        variant="secondary"
                                    >{`${
                                        afficherFiltres ? 'Masquer' : 'Afficher'
                                    } les filtres`}</Button>
                                    {areLignesSelectionnables && (
                                        <Button onClick={majSelectionGlobale} variant="secondary">
                                            Tout sélectionner
                                        </Button>
                                    )}
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <Container fluid={false}>
                            {afficherFiltres && (
                                <>
                                    <Row className="margin-top-md">
                                        <Col col={12}>
                                            <h5>Trier</h5>
                                        </Col>
                                    </Row>
                                    <Row gutters>{creerChampsTri()}</Row>
                                    <Row className="margin-top-md">
                                        <Col col={12}>
                                            <h5>Filtrer</h5>
                                        </Col>
                                    </Row>
                                    <Row gutters>
                                        {columns
                                            .filter((column) => column.filter)
                                            .map((column) => (
                                                <Col col={12} md={6}>
                                                    {getFilterTemplate(column, true)}
                                                </Col>
                                            ))}
                                    </Row>
                                </>
                            )}
                            <Row className="liste-resultats-mobile">
                                {records.map((resultat) => creerCarteResultat(resultat))}
                            </Row>
                        </Container>
                    </>
                }
            />
        </Container>
    );
};

EagerDataTableDesignEtat.propTypes = {
    records: PropTypes.array,
    nombreTotal: PropTypes.number,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            field: PropTypes.string,
            header: PropTypes.string,
            sortable: PropTypes.bool,
            filter: PropTypes.bool,
            template: PropTypes.func,
        }),
    ).isRequired,
    clearFiltersButton: PropTypes.bool,
    rowClassName: PropTypes.func,
    customResultatName: PropTypes.string,
    exportButtonFonction: PropTypes.func,
    rowHover: PropTypes.bool,
    onRowClick: PropTypes.func,
    areLignesSelectionnables: PropTypes.bool,
    selectionListener: PropTypes.func,
    emptyMessage: PropTypes.string,
    clearFiltersForce: PropTypes.bool,
    rechercheIcon: PropTypes.bool,
};

EagerDataTableDesignEtat.defaultProps = {
    records: [],
    nombreTotal: 0,
    clearFiltersButton: false,
    rowClassName: null,
    customResultatName: null,
    rowHover: false,
    emptyMessage: null,
};

export default EagerDataTableDesignEtat;
